import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "38.973",
  width: "50",
  viewBox: "0 0 50 38.973",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M0 0v38.973h50V0H0zm3.557 3.557h42.886v31.86H3.557V3.557zm10.925 7.57c-4.624 0-8.384 3.76-8.384 8.384s3.76 8.387 8.384 8.387H35.52c4.623 0 8.383-3.76 8.383-8.384s-3.76-8.383-8.384-8.383-8.387 3.76-8.387 8.383c0 1.78.56 3.457 1.524 4.828H21.34c.965-1.37 1.524-3.046 1.524-4.825 0-4.623-3.76-8.383-8.384-8.383zm0 3.557c2.642 0 4.827 2.185 4.827 4.827s-2.188 4.83-4.83 4.83c-2.64 0-4.827-2.184-4.827-4.83s2.185-4.824 4.827-4.824zm21.037 0c2.64 0 4.824 2.185 4.824 4.827s-2.185 4.83-4.827 4.83c-2.643 0-4.828-2.184-4.828-4.83s2.184-4.824 4.826-4.824z"
  })]
});